
        var result = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/postcss-loader/index.js!../../../../../../../node_modules/sass-loader/lib/loader.js!../../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./mention-legale.component.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/layouts/footer/mention-legale/mention-legale.component.scss
// module id = 911
// module chunks = 0